import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { stack } from '../data/landing';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="comprar" className="w-full scroll-mt-16 bg-ink text-cream" data-id="element-113" data-mp="1mniuzj2x3ph3">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" data-id="element-114" data-mp="1mplj1xkif8j6">
        <div className="max-w-2xl" data-id="element-115" data-mp="1hph2y8nikfth">
          <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-116" data-mp="1hqiox862impz">
            Al comprar el manual hoy, te llevás el sistema de organización definitivo
          </h2>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10" data-id="element-117" data-mp="p1v0j3q0vh87">
          <ul className="divide-y divide-cream/10 rounded-2xl bg-cream/[0.04] px-6 ring-1 ring-cream/10" data-id="element-118" data-mp="13ylx758baeu4">
            {stack.map(item => <li key={item.name} className="flex items-start gap-4 py-5" data-id="element-119" data-mp="2fbxxx78ryhc2">
                <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${item.kind === 'main' ? 'bg-butter text-ink' : 'bg-cream/10 text-butter'}`} data-id="element-120" data-mp="2fe0wwgrwnksx">
                  {item.kind === 'main' ? <BookOpenIcon aria-hidden="true" className="h-5 w-5" data-id="element-121" data-mp="zi4zvx0exvw9" /> : <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-122" data-mp="13k9r6p3e2gfq" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-123" data-mp="6v0sxmhrf7hu">
                  <p className="font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-cream/50" data-id="element-124" data-mp="bstyqef5hzhl">
                    {item.label}
                  </p>
                  <h3 className={`font-sans font-bold ${item.kind === 'main' ? 'text-lg text-butter' : 'text-base text-cream'}`} data-id="element-125" data-mp="fsuq0zncm562">
                    {item.name}
                  </h3>
                  <p className="mt-1 font-sans text-sm leading-relaxed text-cream/65" data-id="element-126" data-mp="3o9fnpkaj5btv">
                    {item.detail}
                  </p>
                </div>
                <p className="shrink-0 pt-4 font-sans text-sm font-semibold text-cream/70" data-id="element-127" data-mp="qgnqgd7e0yi4">
                  {item.value}
                </p>
              </li>)}
            <li className="flex items-baseline justify-between py-5" data-id="element-128" data-mp="154qv9j9p245c">
              <p className="font-sans text-sm font-bold uppercase tracking-[0.14em] text-cream/60" data-id="element-129" data-mp="107iglsnr8i8u">
                Valor total
              </p>
              <p className="font-display text-2xl font-bold text-cream/60 line-through" data-id="element-130" data-mp="cipoy8e60wk1">
                $38.500
              </p>
            </li>
          </ul>

          <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-131" data-mp="licjqbce3444">
            <div className="rounded-2xl bg-cream p-7 text-ink shadow-lift" data-id="element-132" data-mp="hfg5sxxsnw6i">
              <p className="font-sans text-sm font-bold uppercase tracking-[0.14em] text-tomato" data-id="element-133" data-mp="1wwq0kw8q6jan">
                Precio de lanzamiento
              </p>
              <p className="mt-4 font-sans text-base text-muted line-through" data-id="element-134" data-mp="1sucwsddjgvgi">
                $38.500 ARS
              </p>
              <p className="font-display text-6xl font-black leading-none text-ink" data-id="element-135" data-mp="20gqhrp1uas69">
                $9.900
              </p>
              <p className="mt-1 font-sans text-sm font-semibold text-muted" data-id="element-136" data-mp="1qghjm5oaewo8">
                ARS · pago único, acceso para siempre
              </p>

              <p className="mt-5 rounded-xl bg-sand px-4 py-3 font-sans text-[15px] leading-relaxed text-ink/80" data-id="element-137" data-mp="1vg2sb7t9eje5">
                Pagás menos que una docena de empanadas y te sirve para{' '}
                <strong className="font-bold" data-id="element-138" data-mp="2o2wz51x5lk95">toda la vida</strong>.
              </p>

              <div className="mt-6" data-id="element-139" data-mp="29eak71bfuuig">
                <CtaButton fullWidth size="lg" subLabel="Oferta única válida por hoy · Garantía de 7 días" data-id="element-140" data-mp="29f277nqyzjx4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}